interface SavedCommTemplate {
  source_ats_comm_template_id?: string | number | null;
}

interface EditedEmailActivity {
  ats_comm_template?: SavedCommTemplate | null;
}

/**
 * The saved template is a one-time copy whose own id means nothing to the
 * picker; `source_ats_comm_template_id` is what the user actually chose.
 */
export const seedSelectedTemplate = (
  selected?: EditedEmailActivity | unknown[] | null
): { id?: string | number } => {
  const source = Array.isArray(selected)
    ? undefined
    : selected?.ats_comm_template?.source_ats_comm_template_id;
  return source === undefined || source === null ? {} : { id: source };
};
